export { default as CloseIcon } from './close.svg'
export { default as ListIcon } from './list.svg'
export { default as WhatsAppIcon } from './whatsapp.svg'
export { default as WhatsAppGreen } from './whatsapp-green.svg'
export { default as DarkLinkedInIcon } from './dark-linkedin-icon.svg'
export { default as DarkListIcon } from './dark-list-icon.svg'
export { default as DarkInstagramIcon } from './dark-instagram-icon.svg'
export { default as DarkFacebookIcon } from './dark-facebook-icon.svg'
export { default as WhiteLinkedInIcon } from './white-linkedin-icon.svg'
export { default as WhiteInstagramIcon } from './white-instagram-icon.svg'
export { default as WhiteFacebookIcon } from './white-facebook-icon.svg'
export { default as StarIcon } from './star.svg'
export { default as ArrowRightIcon } from './arrow-right.svg'
export { default as ArrowLeftIcon } from './arrow-left.svg'
export { default as TimelineArrowRightUnpaintedIcon } from './timeline-arrow-right-unpainted.svg'
export { default as TimelineArrowRightPaintedIcon } from './timeline-arrow-right-painted.svg'
export { default as TimelineArrowLeftIcon } from './timeline-arrow-left.svg'
export { default as ChevronHorizontal } from './chevron-horizontal.svg'
export { default as Chevron } from './chevron.svg'
export { default as BlueChevron } from './blue-chevron.svg'
export { default as CloseIconBlack } from './close-black.svg'
export { default as GlobeIcon } from './globe.svg'
export { default as SearchIcon } from './search.svg'
export { default as WhiteGlobe } from './white-globe.svg'
export { default as BrIcon } from './br-icon.svg'
export { default as EnIcon } from './en-icon.svg'
